import { Subject, timer } from 'rxjs';
import { INDRAApiService } from './api.indra.service';
import { URL_SESSION_RENEW } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
var TimeoutSvcService = /** @class */ (function () {
    function TimeoutSvcService(api) {
        this.api = api;
        this._count = 0;
        this._timeoutMilliseconds = 480000; // 8 minutes
        this.resetOnTrigger = false;
        this.timeoutExpired = new Subject();
        this.skipRenewSession$ = new Subject();
        this.isOtherAPILoading$ = new Subject();
        this.timeoutExtension = 0;
        this.sessionTimeoutTimeRemainingInSeconds = null;
        this.sessionExtendIntervalInSeconds = null;
        this.renewLimitReached = false;
    }
    TimeoutSvcService.prototype.setSubscription = function () {
        var _this = this;
        this._timer = timer(this.timeoutExtension ? this.timeoutExtension : this._timeoutMilliseconds);
        this.timerSubscription = this._timer.subscribe(function (n) {
            _this.timeoutExtension = 0; // reset timeoutExtension
            _this.timerComplete(n);
        });
    };
    TimeoutSvcService.prototype.startTimer = function () {
        this.stopTimer();
        this.setSubscription();
    };
    TimeoutSvcService.prototype.stopTimer = function () {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    };
    TimeoutSvcService.prototype.resetTimer = function () {
        this.startTimer();
    };
    TimeoutSvcService.prototype.timerComplete = function (n) {
        this.timeoutExpired.next(++this._count);
        if (this.resetOnTrigger) {
            this.startTimer();
        }
    };
    TimeoutSvcService.prototype.sessionRenew = function () {
        return this.api.INDRA_post(URL_SESSION_RENEW, {});
    };
    TimeoutSvcService.prototype.sessionDelete = function () {
        return this.api.INDRA_delete(URL_SESSION_RENEW, {});
    };
    // call this to avoid parallel calls with /renew
    // by extending timer by 1 minute
    TimeoutSvcService.prototype.INDRA_extendTimer = function () {
        this.timeoutExtension = 60000; // 1 minute
        this.resetTimer();
    };
    TimeoutSvcService.prototype.INDRA_setSessionTimeoutInSeconds = function (value) {
        this._timeoutMilliseconds = value * 1000; // multiply by 1000 for ms
        this.startTimer();
    };
    TimeoutSvcService.prototype.INDRA_setSessionTimeoutTimeRemainingInSeconds = function (value) {
        this.sessionTimeoutTimeRemainingInSeconds = value;
    };
    TimeoutSvcService.prototype.INDRA_getSessionTimeoutTimeRemainingInSeconds = function () {
        return this.sessionTimeoutTimeRemainingInSeconds;
    };
    TimeoutSvcService.prototype.INDRA_setSessionExtendIntervalInSeconds = function (value) {
        this.sessionExtendIntervalInSeconds = value;
    };
    TimeoutSvcService.prototype.INDRA_getSessionExtendIntervalInSeconds = function () {
        return this.sessionExtendIntervalInSeconds;
    };
    TimeoutSvcService.ngInjectableDef = i0.defineInjectable({ factory: function TimeoutSvcService_Factory() { return new TimeoutSvcService(i0.inject(i1.INDRAApiService)); }, token: TimeoutSvcService, providedIn: "root" });
    return TimeoutSvcService;
}());
export { TimeoutSvcService };
